import { FETCH_MONTHLY_TRANSACTION_DATA,} from "../types"
const INIT_STATE = {
    monthlyTransactionData: null,

}
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case FETCH_MONTHLY_TRANSACTION_DATA: return { ...state, monthlyTransactionData: action?.payload || null }
        default: return state
    }
}